import { useAppDispatch, useAppSelector } from '@hooks/reduxHooks'
import { setActiveTab } from '@state/reducers/wasteReducer'
import { ToggleButton, ToggleButtonGroup } from '@mui/material'

export enum WasteTabs {
  Entries = 0,
  Containers = 1,
}

export function WasteTableTabs() {
  const dispatch = useAppDispatch()
  const { activeTab } = useAppSelector(({ waste }) => ({ activeTab: waste.activeTab }))

  return (
    <ToggleButtonGroup
      value={activeTab}
      exclusive
      color="primary"
      onChange={(_, value) => {
        value !== null && dispatch(setActiveTab(value))
      }}
      size="small"
      unselectable="off"
      >
      {[{ value: 0, label: 'Déchets' }, { value: 1, label: 'Conteneurs' }].map(({ value, label }) => (
        <ToggleButton key={label} value={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  )
}
